import DescriptionTooltip from "components/FormField/DescriptionTooltip";

interface FormSectionProps {
  label: React.ReactNode;
  actions?: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
}
export function FormSection({ label, actions, description, children }: FormSectionProps) {
  return (
    <div className="grid grid-cols-5 pt-4 px-2 border-t border-gray-100">
      <div className="flex">
        <div className="flex items-center gap-1 h-8">
          <p className="opacity-60 text-sm font-semibold uppercase">{label}</p>
          <DescriptionTooltip description={description} />
        </div>
        {actions}
      </div>
      <div className="col-start-2 col-span-4 grid gap-4">{children}</div>
    </div>
  );
}
